import React from "react";
import "../App.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// ✅ Replace with your actual images
import before1 from "../assets/images/before1.jpg";
import before2 from "../assets/images/before2.jpg";
import before from "../assets/images/before.jpg";
import patient2 from "../assets/images/patient2.jpg";
import patient3 from "../assets/images/patient3.jpg";
import patient4 from "../assets/images/patient4.jpg";

const images = [
  before1,
  before2,
  before,
  patient2,
  patient3,
  patient4,
];

const PatientGallery = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="patient-gallery-section">
      <h2 className="gallery-title">Our patients’ smiles speak for themselves</h2>
      <div className="slider-wrapper">
        <Slider {...settings}>
          {images.map((src, index) => (
            <div key={index} className="image-slide">
              <img
                src={src}
                alt={`Smile ${index + 1}`}
                className="gallery-img"
                style={{
                  borderRadius: "18px",
                  border: "3px solid #b22280",
                  boxShadow: "0 4px 16px rgba(178,34,128,0.08)",
                  width: "100%",
                  maxWidth: "420px",
                  margin: "0 auto",
                  transition: "transform 0.4s",
                  animation: "fadeIn 1s"
                }}
              />
            </div>
          ))}
        </Slider>
      </div>
      <div style={{ marginTop: "2rem", textAlign: "center" }}>
        <span style={{
          background: "#ea009c",
          color: "#fff",
          borderRadius: "10px",
          padding: "0.5rem 1.2rem",
          fontWeight: "bold",
          fontSize: "0.9rem",
          boxShadow: "0 2px 8px rgba(234,0,156,0.08)"
        }}>
          Book your smile transformation today!
        </span>
      </div>
    </div>
  );
};

export default PatientGallery;